import moment from 'moment';
import { useEffect, useState } from 'react';
import TableLoader from 'shared/common/table-loader';
import '../table.css';

const metals: Record<string, string> = {
    Ag: 'Silver',
    Au: 'Gold',
    Pt: 'Platinum',
    Pd: 'Palladium',
};

const BarAllocationInvoice = ({ invoiceData, invoiceLoading }) => {
    const [data, setData] = useState<any>([]);

    useEffect(() => {
        if (invoiceData) {
            setData(invoiceData);
        }
    }, [invoiceData]);

    return (
        <>
            <div className='txn-wrapper'>
                {invoiceLoading && <TableLoader />}
                <div className='txn-scroll'>
                    <table className='txn-table'>
                        <colgroup>
                            <col style={{ width: '12%' }} />
                            <col style={{ width: '10%' }} />
                            <col style={{ width: '10%' }} />
                            <col style={{ width: '8%' }} />
                            <col style={{ width: '13%' }} />
                            <col style={{ width: '16%' }} />
                            <col style={{ width: '9%' }} />
                            <col style={{ width: '10%' }} />
                        </colgroup>

                        <thead>
                            <tr>
                                <th>Warehouse</th>
                                <th>Bar No</th>
                                <th>VSO ID</th>
                                <th>Metal</th>
                                <th>Order No</th>
                                <th>Order Date</th>
                                <th className='right'>Quantity</th>
                                <th className='center'>VSO Receipt</th>
                            </tr>
                        </thead>

                        <tbody>
                            {invoiceLoading ? (
                                <tr>
                                    <td colSpan={8} className='txn-empty'>
                                        <div className='txn-empty-text'>Loading...</div>
                                    </td>
                                </tr>
                            ) : data.length === 0 ? (
                                <tr>
                                    <td colSpan={8} className='txn-empty'>
                                        <div className='txn-empty-icon'></div>
                                        <div className='txn-empty-text'>No data available</div>
                                    </td>
                                </tr>
                            ) : (
                                data.map((metal: any, index: number) => (
                                    <tr key={metal.vsoId || metal.barNo || index} className='txn-row-single'>

                                        {/* Warehouse */}
                                        <td>
                                            <span className='txn-order-id'>{metal.warehouseId}</span>
                                        </td>

                                        {/* Bar No */}
                                        <td>
                                            <span className='txn-order-id'>{metal.barNo}</span>
                                        </td>

                                        {/* VSO ID */}
                                        <td>
                                            <span className='txn-order-id'>{metal.vsoId}</span>
                                        </td>

                                        {/* Metal */}
                                        <td>
                                            <span
                                                className='txn-type-badge'
                                                style={{
                                                    background: '#EEE8F7',
                                                    color: '#301250',
                                                }}
                                            >
                                                {metals[metal.metalCode] ?? metal.metalCode}
                                            </span>
                                        </td>

                                        {/* Order No */}
                                        <td>
                                            <span className='txn-order-id'>{metal.ebOrderRef}</span>
                                        </td>

                                        {/* Order Date */}
                                        <td>
                                            <div className='txn-date'>
                                                {moment(metal.orderDate).format('DD MMM YYYY')}
                                            </div>
                                            <div className='txn-time'>
                                                {moment(metal.orderDate).format('hh:mm A')}
                                            </div>
                                        </td>

                                        {/* Quantity */}
                                        <td className='right'>
                                            <span className='txn-amount-parent'>{metal.quantity} g</span>
                                        </td>

                                        {/* VSO Receipt */}
                                        <td className='center'>
                                            {metal.pdfUrl ? (
                                                <a
                                                    href={metal.pdfUrl}
                                                    target='_blank'
                                                    rel='noopener noreferrer'
                                                    className='txn-view-btn'
                                                    style={{ textDecoration: 'none' }}
                                                >
                                                    <svg width='12' height='12' viewBox='0 0 24 24' fill='none'>
                                                        <path
                                                            d='M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6z'
                                                            stroke='currentColor'
                                                            strokeWidth='2'
                                                            strokeLinecap='round'
                                                            strokeLinejoin='round'
                                                        />
                                                        <path
                                                            d='M14 2v6h6M16 13H8M16 17H8M10 9H8'
                                                            stroke='currentColor'
                                                            strokeWidth='2'
                                                            strokeLinecap='round'
                                                            strokeLinejoin='round'
                                                        />
                                                    </svg>
                                                    View
                                                </a>
                                            ) : (
                                                <span style={{ color: '#9CA3AF', fontSize: '13px' }}>—</span>
                                            )}
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
};

export default BarAllocationInvoice;